import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { useAuthStore } from '../../store/authStore';
import { usePricingStore } from '../../store/pricingStore';

interface TopBarProps {
  onToggleSidebar: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onToggleSidebar }) => {
  const { user } = useAuthStore();
  const openPricingModal = usePricingStore((s) => s.openPricingModal);

  const hasSubscription = user?.subscription_expiry && new Date(user.subscription_expiry) > new Date();
  const daysLeft = user?.subscription_expiry
    ? Math.max(0, Math.ceil((new Date(user.subscription_expiry).getTime() - Date.now()) / 86400000))
    : 0;

  return (
    <header className="top-bar">
      <button
        onClick={onToggleSidebar}
        className="p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-accent transition-colors mr-auto"
      >
        <Bars3Icon className="w-5 h-5" />
      </button>

      <div className="top-bar-item">
        <span className="label">字数剩余</span>
        <span className={`value${user?.words_quota != null && user.words_quota <= 500 ? ' text-red-500' : ''}`}>
          {user?.words_quota != null ? user.words_quota.toLocaleString() : hasSubscription ? '--' : '免费版'}
        </span>
      </div>
      <div className="top-bar-divider" />
      <div className="top-bar-item">
        <span className="label">到期</span>
        <span
          className="value clickable"
          onClick={openPricingModal}
          title="点击充值/续费"
        >
          {hasSubscription ? `${daysLeft}天` : '免费版'}
        </span>
      </div>
      <div className="top-bar-divider" />
      <button className="top-bar-item hover:text-foreground transition-colors">
        <span>帮助</span>
      </button>
    </header>
  );
};

export default TopBar;
